import { Dispatch } from 'react';

import { Action, ActionResult } from './types';

type BoundActions<Args extends Record<string, unknown[]>> = {
    [Key in keyof Args]: (...args: Args[Key]) => void;
};

export default function bindActions<Args extends Record<string, unknown[]>>(
    actions: { [Key in keyof Args]: Action<Args[Key]> },
    dispatch: Dispatch<ActionResult>,
): BoundActions<Args> {
    if (typeof actions !== 'object' || actions === null) {
        throw new Error(
            `bindActions expected an object or a function, instead received ${
                actions === null ? 'null' : typeof actions
            }. `,
        );
    }
    const boundActions = {} as BoundActions<Args>;
    for (const key in actions) {
        const action = actions[key];
        if (typeof action === 'function') {
            boundActions[key] = (...args) => dispatch(action(...args));
        }
    }
    return boundActions;
}
